import resetPasswordPrompt from "emun.auth/reset-password/reset-password-prompt";

export default $parse => ({
  scope: false,
  link(scope, element, attr) {
    const ngModel = {
      open(e) {
        return resetPasswordPrompt(attr).then(
          args => $parse(attr.onPasswordChanged)(scope, args),
          args => $parse(attr.onDismissed)(scope, args)
        );
      }
    };

    if (attr.ngModel) {
      $parse(attr.ngModel).assign(scope, ngModel);
    }

    const $targets = attr.resetPasswordPromptClickSelector
      ? element.find(attr.resetPasswordPromptClickSelector)
      : element;
    $targets.on("click", ngModel.open);
  }
});
